<template>
  <rect
    width="21"
    height="21"
    rx="4"
    transform="matrix(-1 0 0 1 21 0)"
    fill="#0A1B33"
  />
  <rect
    x="-0.5"
    y="0.5"
    width="20"
    height="20"
    rx="3.5"
    transform="matrix(-1 0 0 1 20 0)"
    stroke="white"
    stroke-opacity="0.1"
  />
  <path
    opacity="0.5"
    d="M12 7L8 10.5L12 14"
    stroke="white"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
